import { render, staticRenderFns } from "./Unidade.vue?vue&type=template&id=7158d578&scoped=true&"
import script from "./Unidade.vue?vue&type=script&lang=js&"
export * from "./Unidade.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7158d578",
  null
  
)

export default component.exports